import React from 'react';
import { getSortedRoles } from '../../../mappers/roleMap';
import RoleInitial from '../../shared/RoleInitial';
import ContentHandler from '../../shared/ContentHandler';
export const RolesList = ({ roles }) => (<span>
    {getSortedRoles(roles).map((role, index) => (<span key={index}>
        <RoleInitial role={role}/>
        <ContentHandler shouldDisplayContent={index < roles.length - 1}>
          <span>{'/'}</span>
        </ContentHandler>
      </span>))}
  </span>);
export default RolesList;
